import { AttestationType } from '#types/loreTypes.tsx'
import generateRootMeta from './rootMeta'

const generateCollectionMeta = ({
	origin,
	path,
	collectionAttestation,
}: {
	origin: string
	path: string
	collectionAttestation?: AttestationType
}) => {
	if (collectionAttestation) {
		let queryParams = ''
		let ogImageUrl = `${origin}/lore-og-image.png`
		const rawCollectionName =
			collectionAttestation.properties?.name || undefined
		const collectionName = rawCollectionName
			? `Atomic Lore for the ${rawCollectionName} NFT Collection`
			: 'Atomic Lore for an NFT Collection'
		const collectionDescription = rawCollectionName
			? `Cryptophraphically signed story and history for the ${rawCollectionName} NFT Collection, beautifully displayed.`
			: 'Cryptophraphically signed story and history for an NFT Collection, beautifully displayed.'
		const splitParams = path.split('/').slice(1)
		if (splitParams[0] === 'collectionProfile') {
			queryParams = `?cid=${splitParams[1]}`
			ogImageUrl = collectionAttestation.properties?.imageUrl
				? `${origin}/metadataImage${queryParams}`
				: `${origin}/lore-og-image.png`
		} else {
			queryParams = `?cid=${splitParams[splitParams.length - 1]}`
			ogImageUrl =
				queryParams.length > 0
					? `${origin}/metadataImage${queryParams}`
					: `${origin}/lore-og-image.png`
		}
		return [
			{
				title: collectionName,
			},
			{
				property: 'og:title',
				content: collectionName,
			},
			{ property: 'og:url', content: origin + path },
			{
				name: 'description',
				content: collectionDescription,
			},
			{
				property: 'og:description',
				content: collectionDescription,
			},
			{ property: 'og:site_name', content: 'atomiclore.io' },
			// IMAGE
			{ name: 'image', content: ogImageUrl },
			{ property: 'og:image', content: ogImageUrl },
			{ property: 'og:image:width', content: '1200px' },
			{ property: 'og:image:height', content: '630px' },
			// TWITTER / SLACK
			{ name: 'twitter:image', content: ogImageUrl },
			{ name: 'twitter:card', content: 'summary_large_image' },
			{ name: 'twitter:site', content: '@atomicform' },
			{ name: 'twitter:creator', content: '@atomicform' },
			{
				name: 'twitter:description',
				content: collectionDescription,
			},
			{
				name: 'twitter:title',
				content: collectionName,
			},
		]
	}
	const metaPayload = generateRootMeta({ path, origin })
	return metaPayload
}

export default generateCollectionMeta
